import api from './api';

export const backupService = {
  /**
   * Export user data as JSON (user-specific backup)
   */
  async exportUserData(): Promise<Blob> {
    const response = await api.get('/backup/export', {
      responseType: 'blob',
    });
    return response.data;
  },

  /**
   * Import user data from JSON file
   */
  async importUserData(file: File): Promise<{ success: boolean; message: string; errors?: string[] }> {
    const content = await file.text();
    const data = JSON.parse(content);
    const response = await api.post<{ success: boolean; message: string; errors?: string[] }>('/backup/import', data);
    return response.data;
  },

  /**
   * Export full database (admin only)
   */
  async exportAdmin(): Promise<Blob> {
    const response = await api.get('/backup/admin/export', {
      responseType: 'blob',
    });
    return response.data;
  },

  /**
   * Import full database (admin only)
   */
  async importAdmin(file: File): Promise<{ success: boolean; message: string; errors?: string[] }> {
    const content = await file.text();
    const data = JSON.parse(content);
    const response = await api.post<{ success: boolean; message: string; errors?: string[] }>('/backup/admin/import', data);
    return response.data;
  },

  /**
   * Helper to download blob as file
   */
  downloadBlob(blob: Blob, filename: string): void {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  },
};
